module.exports = __webpack_public_path__ + "img/upward.b2cff36c.svg";